import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Servidor from "../config/Servidor";
import "./CrearUsuarios.css";

export default function CrearUsuarios() {
  const navigate = useNavigate();

  const [roles, setRoles] = useState([]);
  const [nombreRolSeleccionado, setNombreRolSeleccionado] = useState("");
  const [mostrarModalSupervisor, setMostrarModalSupervisor] = useState(false);
  const [mostrarModalConfirm, setMostrarModalConfirm] = useState(false);
  const [supervisores, setSupervisores] = useState([]);
  const [busquedaSupervisor, setBusquedaSupervisor] = useState("");
  const [supervisorSeleccionado, setSupervisorSeleccionado] = useState(null);
  const [errorDuplicado, setErrorDuplicado] = useState("");
  const [mostrarModalMensaje, setMostrarModalMensaje] = useState(false);
const [mensajeModal, setMensajeModal] = useState("");
const [tipoModal, setTipoModal] = useState("info"); // success | error | info
const [cargando, setCargando] = useState(false);
const hoy = new Date().toISOString().split("T")[0];

  const [form, setForm] = useState({
    cedula: "",
    nombre: "",
    primerapellido: "",
    segundoapellido: "",
    celular: "",
    fechan: "",
    usuario: "",
    contraseña: "",
     fecha: hoy,    
    fecha_vencimiento: "",
    meses_pagados: "",
     activo: "1",    
    id_rol: "",
    id_supervisor: "",
    latitud: "",
    longitud: "",
    ingreso: "",
    pendiente_tema: 0,
    color1: "#ff0740a0",
    color2: "#ffffffff",
    color3: "#ffffffff",  
    color4: "#ff000000",
  });

  //colores flutter 
  // Convierte #AARRGGBB (Flutter) a #RRGGBB (Web)
const flutterToWebColor = (flutterColor) => {
  if (!flutterColor || flutterColor.length !== 9) return flutterColor;

  const a = flutterColor.substring(1, 3);
  const r = flutterColor.substring(3, 5);
  const g = flutterColor.substring(5, 7);
  const b = flutterColor.substring(7, 9);

  return `#${r}${g}${b}`;
};

  useEffect(() => {
    axios.get(`${Servidor.IP}/roles`).then(res => setRoles(res.data)).catch(() => console.log("Error roles"));
    axios.get(`${Servidor.IP}/supervisores`).then(res => setSupervisores(res.data)).catch(() => console.log("Error supervisores"));
  }, []);
useEffect(() => {

  const handlePopState = () => {

    // Si hay algún modal abierto, lo cerramos
    if (mostrarModalSupervisor) {
      setMostrarModalSupervisor(false);
      window.history.pushState(null, "", window.location.href);
      return;
    }

    if (mostrarModalConfirm) {
      setMostrarModalConfirm(false);
      window.history.pushState(null, "", window.location.href);
      return;
    }

    if (mostrarModalMensaje) {
      setMostrarModalMensaje(false);
      window.history.pushState(null, "", window.location.href);
      return;
    }
  };

  window.addEventListener("popstate", handlePopState);

  return () => {
    window.removeEventListener("popstate", handlePopState);
  };

}, [mostrarModalSupervisor, mostrarModalConfirm, mostrarModalMensaje]);
  const calcularVencimiento = (fechaBase, meses) => {
    if (!fechaBase || !meses) return "";
    const fecha = new Date(fechaBase);
    fecha.setMonth(fecha.getMonth() + parseInt(meses));
    return fecha.toISOString().split("T")[0];
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedForm = { ...form, [name]: value };
    if (name === "meses_pagados" || name === "fecha") {
      updatedForm.fecha_vencimiento = calcularVencimiento(
        name === "fecha" ? value : form.fecha,
        name === "meses_pagados" ? value : form.meses_pagados
      );
    }
    setForm(updatedForm);
    setErrorDuplicado(""); // reset error duplicado al cambiar
  };

  const handleRolChange = (e) => {
    const selectedId = e.target.value;
    const rol = roles.find(r => r.id_rol.toString() === selectedId);
    setForm({ ...form, id_rol: selectedId ? Number(selectedId) : "" });
    setNombreRolSeleccionado(rol?.nombre || "");
  };

const supervisoresFiltrados = supervisores.filter(sup =>
  sup.nombre.toLowerCase().includes(busquedaSupervisor.toLowerCase()) ||
  sup.primerapellido.toLowerCase().includes(busquedaSupervisor.toLowerCase()) ||
  sup.id_usuario.toString().includes(busquedaSupervisor)
);

  // Validar campos obligatorios
  const camposCompletos = () => {
    const requiredFields = [
      "cedula", "nombre", "primerapellido", "usuario",
      "contraseña", "fecha", "meses_pagados", "activo", "id_rol"
    ];
    for (let field of requiredFields) {
      if (!form[field]) return false;
    }
    if (nombreRolSeleccionado === "Cobrador" && !supervisorSeleccionado) return false;
    return true;
  };

  // Abrir modal confirmación solo si todos los campos completos
const abrirModalConfirm = async () => {
  // 1️⃣ Validar campos completos
  if (!camposCompletos()) {
    setMensajeModal("Completa todos los campos obligatorios y selecciona supervisor si es Cobrador.");
    setMostrarModalMensaje(true);
    window.history.pushState({ modal: true }, "");
    return;
  }

  try {
    // 2️⃣ Verificar duplicados
    const res = await axios.post(`${Servidor.IP}/verificar-usuario`, {
      cedula: form.cedula,
      usuario: form.usuario
    });

    if (!res.data.ok) {
      setMensajeModal(res.data.msg || "Cédula o usuario ya existen.");
      setMostrarModalMensaje(true);
      window.history.pushState({ modal: true }, "");
      return;
    }

    // 3️⃣ Si no hay duplicados, abrir modal confirmación
    setMostrarModalConfirm(true);
      window.history.pushState({ modal: true }, "");

  } catch (err) {
    console.log(err);
    setMensajeModal("Error al verificar usuario existente.");
    setMostrarModalMensaje(true);
    window.history.pushState({ modal: true }, "");
  }
};

  // Confirmar creación
const confirmarCrearUsuario = async () => {
  setMostrarModalConfirm(false);
  setCargando(true);

  const formData = {
    ...form,
    id_supervisor: supervisorSeleccionado
      ? supervisorSeleccionado.id_usuario
      : null
  };

  try {
    const res = await axios.post(`${Servidor.IP}/crearusuario`, formData);

    if (res.data.ok) {
      setTipoModal("success");
      setMensajeModal("Usuario creado correctamente ✅");
      setMostrarModalMensaje(true);
      window.history.pushState({ modal: true }, "");

      // Redirigir después de 1.5 segundos
      setTimeout(() => {
        navigate("/ingresoadmin");
      }, 1500);
    } else {
      setTipoModal("error");
      setMensajeModal("No se pudo crear el usuario.");
      setMostrarModalMensaje(true);
      window.history.pushState({ modal: true }, "");
    }

  } catch (err) {
    console.log(err);
    setTipoModal("error");
    setMensajeModal("Error al crear usuario.");
    setMostrarModalMensaje(true);
    window.history.pushState({ modal: true }, "");
  }

  setCargando(false);
};
  return (
    <div className="crear-container">
       <div className="header-usuarios">
  <button className="volver" onClick={() => navigate("/ingresoadmin")}>
        <span className="flecha-volver">↩</span>
          <span>Volver</span>
  </button>
  <h1 className="usuarios-title">Crear Usuario</h1>
</div>
      {errorDuplicado && <p style={{color:"red"}}>{errorDuplicado}</p>}
      <div className="form">
        <h2>Datos Personales</h2>
        {["Cedula","Nombre","Primer Apellido","Segundo Apellido","Celular"].map(key => (
          <div className="input-group" key={key}>
            <label>{key}</label>
            <input name={key} value={form[key]} onChange={handleChange} />
          </div>
        ))}
        <div className="input-group">
          <label>Fecha de Nacimiento</label>
          <input type="date" name="fechan" value={form.fechan} onChange={handleChange} />
        </div>

        <h2>Datos del Usuario</h2>
        {["Usuario","Contraseña"].map(key => (
          <div className="input-group" key={key}>
            <label>{key}</label>
            <input type="text" name={key} value={form[key]} onChange={handleChange} />
          </div>
        ))}
        <div className="input-group">
          <label>Fecha de Inicio</label>
          <input type="date" name="fecha" value={form.fecha} onChange={handleChange} />
        </div>
        <div className="input-group">
          <label>Meses Pagados</label>
          <input type="number" name="meses_pagados" value={form.meses_pagados} onChange={handleChange} />
        </div>
        <div className="input-group">
          <label>Fecha de Vencimiento</label>
          <input type="date" name="fecha_vencimiento" value={form.fecha_vencimiento} readOnly />
        </div>
        <div className="input-group">
          <label>Estado</label>
          <select name="activo" value={form.activo} onChange={handleChange}>
            <option value="">Seleccione</option>
            <option value="1">Activo</option>
            <option value="0">Inactivo</option>
          </select>
        </div>
        <div className="input-group">
          <label>Rol</label>
          <select name="id_rol" value={form.id_rol} onChange={handleRolChange}>
            <option value="">Seleccione Rol</option>
            {roles.map((rol) => (
              <option key={rol.id_rol} value={rol.id_rol}>{rol.nombre}</option>
            ))}
          </select>
        </div>

        {nombreRolSeleccionado === "Cobrador" && (
          <div className="input-group">
            <label>Supervisor asignado:</label>
         <button
  type="button"
  onClick={() => {
    setMostrarModalSupervisor(true);
    window.history.pushState({ modal: true }, "");
  }}
>
  Seleccionar Supervisor
</button>
          {supervisorSeleccionado && (
  <div className="supervisor-info">
    ID: {supervisorSeleccionado.id_usuario} - {supervisorSeleccionado.nombre} {supervisorSeleccionado.primerapellido}
  </div>
)}

          </div>
        )}

    {(nombreRolSeleccionado === "Cobrador" || 
  nombreRolSeleccionado === "Independiente") && (

  <div className="color-section-compact">
    <h3 className="color-title-compact">🎨 Colores del Sistema</h3>

    <div className="color-grid">
      {["color1","color2","color3","color4"].map((colorKey,index)=>(
        <div className="color-item" key={colorKey}>
          <span className="color-label">
            {index===0?"Principal":
             index===1?"Fondo":
             index===2?"Texto Boton":
             "Texto Letra"}
          </span>

          <input 
            type="color" 
            value={flutterToWebColor(form[colorKey])}
            onChange={(e) => {
              const webColor = e.target.value;
              const flutterColor = "#ff" + webColor.replace("#", "");
              setForm({ ...form, [colorKey]: flutterColor });
            }}
          />
        </div>
      ))}
    </div>
  </div>
)}
      </div>

      <button className="crear-btn" onClick={abrirModalConfirm}>Crear Usuario</button>

      {/* Modal supervisores */}
   {mostrarModalSupervisor && (
  <div className="modal-overlay">
    <div className="modal modal-supervisor">
      <h3>Seleccionar Supervisor</h3>

      <input
        type="text"
        placeholder="Buscar por ID, nombre o primer apellido..."
        value={busquedaSupervisor}
        onChange={e => setBusquedaSupervisor(e.target.value)}
        className="buscador-supervisor"
      />

      <div className="supervisores-list">
        {supervisoresFiltrados.length === 0 ? (
          <p className="no-supervisores">No hay supervisores disponibles</p>
        ) : (
          supervisoresFiltrados.map(sup => (
            <button
              key={sup.id_usuario}
              className="supervisor-btn"
              onClick={() => {
                setSupervisorSeleccionado(sup);
                setMostrarModalSupervisor(false);
              }}
            >
              {sup.id_usuario} - {sup.nombre} {sup.primerapellido}
            </button>
          ))
        )}
      </div>

      <button
        className="modal-cancel"
        onClick={() => setMostrarModalSupervisor(false)}
      >
        Cancelar
      </button>
    </div>
  </div>
)}

      {/* Modal confirmación de creación */}
 {mostrarModalConfirm && (
  <div className="modal-overlay">
    <div className="modal modal-confirm">
      <h3>¿Desea crear el usuario?</h3>
      <div className="modal-actions">
        <button 
          className="btn-confirm btn-yes"
          onClick={confirmarCrearUsuario}
          disabled={cargando}
        >
          Sí
        </button>
        <button 
          className="btn-confirm btn-no"
          onClick={()=>setMostrarModalConfirm(false)}
        >
          No
        </button>
      </div>
    </div>
  </div>
)}

    {/* Modal confirmar usuario*/}
{mostrarModalMensaje && (
  <div className="modal-overlay">
    <div className={`modal modal-alert ${tipoModal}`}>
      <h3>
        {tipoModal === "success" && "✅ Éxito"}
        {tipoModal === "error" && "❌ Error"}
        {tipoModal === "info" && "⚠ Atención"}
      </h3>

      <p>{mensajeModal}</p>

      <button
        className="modal-ok"
        onClick={() => setMostrarModalMensaje(false)}
      >
        Cerrar
      </button>
    </div>
  </div>
)}
    </div>
  );
}
